<script>
export default {
    name: 'IconCall',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-call"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M41.466 38.233c1.306-.69 2.685-.844 3.654-.253.862.527 8.94 5.888 9.819 6.503 1.261.884 1.44 2.91.309 4.523-2.208 3.16-5.943 7.054-7.903 6.993-.96-.03-1.617-.092-2.639-.304-1.48-.308-3.117-.859-4.947-1.719-4.82-2.263-10.42-6.392-16.883-12.857-6.462-6.463-10.59-12.063-12.853-16.883-.86-1.83-1.41-3.469-1.718-4.949a13.62 13.62 0 01-.304-2.64c-.063-1.959 3.824-5.692 6.991-7.906 1.607-1.12 3.626-.93 4.516.3.495.686 5.783 8.688 6.499 9.818.612.964.454 2.348-.243 3.667-.139.266-.967 1.74-2.484 4.425.48 2.033 2.387 4.716 5.72 8.049 3.333 3.333 6.015 5.239 8.044 5.716a426.481 426.481 0 014.422-2.483z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
